/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGetwizercompanyreportGetWizerCompanyReportUsers
 */
export interface JumboGetwizercompanyreportGetWizerCompanyReportUsers {
    /**
     * 
     * @type {number}
     * @memberof JumboGetwizercompanyreportGetWizerCompanyReportUsers
     */
    invited?: number;
    /**
     * 
     * @type {number}
     * @memberof JumboGetwizercompanyreportGetWizerCompanyReportUsers
     */
    notRegistered?: number;
    /**
     * 
     * @type {number}
     * @memberof JumboGetwizercompanyreportGetWizerCompanyReportUsers
     */
    registered?: number;
}

/**
 * Check if a given object implements the JumboGetwizercompanyreportGetWizerCompanyReportUsers interface.
 */
export function instanceOfJumboGetwizercompanyreportGetWizerCompanyReportUsers(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetwizercompanyreportGetWizerCompanyReportUsersFromJSON(json: any): JumboGetwizercompanyreportGetWizerCompanyReportUsers {
    return JumboGetwizercompanyreportGetWizerCompanyReportUsersFromJSONTyped(json, false);
}

export function JumboGetwizercompanyreportGetWizerCompanyReportUsersFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetwizercompanyreportGetWizerCompanyReportUsers {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'invited': !exists(json, 'invited') ? undefined : json['invited'],
        'notRegistered': !exists(json, 'notRegistered') ? undefined : json['notRegistered'],
        'registered': !exists(json, 'registered') ? undefined : json['registered'],
    };
}

export function JumboGetwizercompanyreportGetWizerCompanyReportUsersToJSON(value?: JumboGetwizercompanyreportGetWizerCompanyReportUsers | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'invited': value.invited,
        'notRegistered': value.notRegistered,
        'registered': value.registered,
    };
}

